var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraChange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.787,
    height: 91.787,
    viewBox: "0 0 91.787 91.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11449",
    "data-name": "Grupo 11449",
    transform: "translate(-604.105 -149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7290",
    "data-name": "Grupo 7290",
    transform: "translate(612.105 157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_532",
    "data-name": "Grupo 532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    fill: "#9eaced",
    stroke: "#f1f6f9",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.894,
    cy: 37.894,
    r: 37.894,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.894,
    cy: 37.894,
    r: 41.894,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7390",
    "data-name": "Grupo 7390",
    transform: "translate(627.379 175.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4730",
    "data-name": "Trazado 4730",
    d: "M130.015,265.869h-9.248l-.9-2.7a4.148,4.148,0,0,0-3.941-2.84H107a4.149,4.149,0,0,0-3.941,2.84l-.9,2.7H99.922v-2.308a3.235,3.235,0,0,0-3.231-3.231H94.845a3.235,3.235,0,0,0-3.231,3.231v2.475a5.086,5.086,0,0,0-3.785,4.91v24a5.083,5.083,0,0,0,5.077,5.077h37.109a5.083,5.083,0,0,0,5.077-5.077v-24A5.083,5.083,0,0,0,130.015,265.869Zm-35.632-2.308a.462.462,0,0,1,.462-.462h1.846a.462.462,0,0,1,.462.462v2.308h-2.77Zm37.94,31.386a2.31,2.31,0,0,1-2.308,2.308H92.906a2.31,2.31,0,0,1-2.308-2.308v-24a2.311,2.311,0,0,1,2.308-2.308h10.246a1.385,1.385,0,0,0,1.314-.947l1.214-3.645A1.383,1.383,0,0,1,107,263.1h8.931a1.383,1.383,0,0,1,1.314.947l1.214,3.645a1.385,1.385,0,0,0,1.314.947h10.246a2.311,2.311,0,0,1,2.308,2.308Z",
    transform: "translate(-87.829 -260.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_136",
    "data-name": "Elipse 136",
    cx: 1.385,
    cy: 1.385,
    rx: 1.385,
    ry: 1.385,
    transform: "translate(38.863 11.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4731",
    "data-name": "Trazado 4731",
    d: "M102.508,281.034H99.739a1.385,1.385,0,0,0,0,2.769h2.769a1.385,1.385,0,0,0,0-2.769Z",
    transform: "translate(-92.723 -269.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5140",
    "data-name": "Grupo 5140",
    transform: "translate(16.708 14.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4733",
    "data-name": "Trazado 4733",
    d: "M125.982,301.783a6.923,6.923,0,1,1,6.923-6.923A6.931,6.931,0,0,1,125.982,301.783Zm0-11.077a4.154,4.154,0,1,0,4.154,4.154A4.159,4.159,0,0,0,125.982,290.705Z",
    transform: "translate(-119.058 -287.936)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraChange);
export default __webpack_public_path__ + "static/media/camera_change.8cd80cd9e81c7d9b5fa91d1b0bef54a4.svg";
export { ForwardRef as ReactComponent };